<template>
  <b-modal ref="modal" size="lg" hide-footer hide-header>
    <div class="modal-content-box">
      <b-container fluid>
        <b-row class="text-center">
          <b-col
            ><p>
              <strong>{{ modalData.title }}</strong>
            </p></b-col
          >
        </b-row>
        <b-row class="text-center">
          <b-col>
            <p>
              <button-cmp variant="primary" @click="yesAction" class="button">{{ modalData.yesBtnText }}</button-cmp>
            </p>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col
            ><button-cmp @click="hide" class="button">{{ modalData.noBtnText }}</button-cmp></b-col
          >
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import ButtonCmp from "@/components/common/button";

export default {
  name: "UserConfirmationModal",
  components: { ButtonCmp },
  data() {
    return {
      modalData: {
        title: "",
        yesBtnText: "",
        noBtnText: ""
      },
      resolve: null,
      reject: null
    };
  },
  methods: {
    open(title, yesBtnText, noBtnText) {
      this.modalData = Object.assign(this.modalData, {
        title,
        yesBtnText,
        noBtnText
      });
      this.$refs.modal.show();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    hide() {
      this.reject(true);
      this.$refs.modal.hide();
    },
    yesAction() {
      this.resolve(true);
      this.$refs.modal.hide();
    }
  }
};
</script>

<style scoped>
.modal-content-box {
  padding: 50px 0px;
}
.button {
  text-transform: none;
  border-radius: 25px;
  width: 80%;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}
</style>
